import { memo, useCallback, useState } from 'react';
import { Navigate, NavigateFunction, Route, Routes, useNavigate, useResolvedPath } from 'react-router-dom';
import { Appointment_KeydropRoutePaths, PathName } from '../../../../helpers/Routes';
import { AppointmentDispatchTypes, useAppointmentDispatch, useAppointmentState } from '../../../../context/Appointment/appointment';
import { useKioskState } from '../../../../context/Kiosk/kiosk';
import { GMDoubleCheckLocker } from '../../../../controls/DoubleCheckLocker';
import { KeyDrop } from './KeyDrop/KeyDrop';
import { KeyDropRoutesProps } from './KeyDropRoutes.types';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { IAppointment, updateAppointmentKeyStatus } from '../../../../API/GoMoto';

/**
 * Routing component for the Store Key section of the Express, Cube, and 24/7 Kiosks.
 *
 * @param onProceed - {@link KeyDropProps.onProceed onProceed} description.
 * @param onSkip - {@link KeyDropProps.onSkip onSkip} description.
 */
export const KeyDropRoutes: GoMotoComponent<KeyDropRoutesProps> = memo(({
    onProceed,
    onSkip,
}) => {
    const { pathname } = useResolvedPath('.');
    const navigate: NavigateFunction = useNavigate();
    const appointmentDispatch = useAppointmentDispatch();
    const appointment: IAppointment = useAppointmentState();
    const { kioskType } = useKioskState();
    const [doubleChecking, setDoubleChecking] = useState<boolean>(false);
    const [sessionLockerId, setSessionLockerId] = useState<number | undefined>(undefined);
    const handleLockerAssigned = useCallback((id: number) => {
        setSessionLockerId(id);
    }, []);

    return (
        <Routes>
            <Route
                path={PathName(Appointment_KeydropRoutePaths.Locker, '*')}
                element={
                    <KeyDrop
                        onProceed={() => {
                            if (kioskType === 'express') {
                                navigate(PathName(pathname, Appointment_KeydropRoutePaths.DoubleCheck));
                            }
                            else {
                                onProceed();
                            }
                        }}
                        onSkip={onSkip}
                        doubleChecking={doubleChecking}
                        sessionLockerId={sessionLockerId}
                        onLockerAssigned={handleLockerAssigned}
                    />
                }
            />
            <Route
                path={PathName(Appointment_KeydropRoutePaths.DoubleCheck, '*')}
                element={
                    <GMDoubleCheckLocker
                        lockerOperationType={'drop-off'}
                        onContinue={onProceed}
                        onReopenLocker={async () => {
                            setDoubleChecking(true);
                            await updateAppointmentKeyStatus(appointment.key, 'reopen requested dropoff');
                            appointmentDispatch({
                                type: AppointmentDispatchTypes.Update,
                                payload: {
                                    ...appointment,
                                    keyStatus: 'reopen requested dropoff',
                                },
                            });
                            navigate(PathName(pathname, Appointment_KeydropRoutePaths.Locker));
                        }}
                    />
                }
            />
            <Route
                path={'*'}
                element={
                    <Navigate
                        replace
                        to={PathName(pathname, Appointment_KeydropRoutePaths.Locker)}
                    />
                }
            />
        </Routes>
    );
});